import api from '@/api'
import qs from 'qs'

export default {
  // 检查登录状态的接口
  checkLogin () {
    return api({
      url: '/checkLogin',
      method: 'GET'
    })
  },
  // 登录前，用于获取盐和token的接口
  getSalt (username) {
    return api({
      url: `/salt/${username}`,
      method: 'GET'
    })
  },
  // 登录接口
  login (type, data) {
    return api({
      url: `/login/${type}`,
      method: 'POST',
      data: qs.stringify(data)
    })
  },
  // 获取当前用户的角色 Code 列表
  getRoleCodes () {
    return api({
      url: '/roleCodes',
      method: 'GET'
    })
  },
  // 已登录用户选择角色
  checkoutRole (code) {
    return api({
      url: '/checkoutRole',
      method: 'GET',
      params: { code }
    })
  },
  // 退出接口
  logout () {
    return api({
      url: '/logout',
      method: 'POST'
    })
  },
  // 获取公钥
  getPublicKey (username) {
    return api({
      url: '/index/getPublicKey',
      method: 'POST',
      data: {
        username
      }
    })
  },
  // 验证loginName是否存在
  checkLoginName (loginName) {
    return api({
      url: `/user/forgetPassword/${loginName}`,
      method: 'PUT'
    })
  }
}
